<ng-container *ngIf="worksheetItem.WorksheetType == 0">
  <!-- pdf -->

  <div class="card border">
    <div class="img-wrapper">
      <img
        [src]="worksheetItem.Image | contentImage : '7'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
        class="w-100"
      />
    </div>
    <div class="worksheet-item-desc">
      <!-- <h4 class="worksheet-item-title">{{ worksheetItem.Title }}</h4> -->
      <div class="worksheet-item-description mb-3">{{ worksheetItem.Description }}</div>
      <button
        target="_blank"
        (click)="getDownload(worksheetId, worksheetItem.Id)"
        class="download-btn text-white border rounded-4 w-100"
      >
        {{ 'worksheet.download' | translate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Gallery">
  <!-- image -->
  <div class="card border-0 shadow my-3 rounded p-2">
    <div>
      <img
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
        style="height: 55px; max-width: 200px"
      />

      <div class="my-2 fw-bold">{{ worksheetItem.Description }}</div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.ProviderVideo">
  <!-- video -->
  <div class="video-card rounded">
    <div [ngSwitch]="worksheetItem.ProviderId">
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey" [height]="videoHeight"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Link">
  <!-- link -->
  <div class="card border-0 my-3 rounded p-2">
    <div>
      <img
        style="height: 55px; max-width: 200px"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />

      <div class="my-2 fw-bold">{{ worksheetItem.Description }}</div>

      <a target="_blank" [href]="worksheetItem.LinkUrl" class="download-btn text-white border rounded-4 mt-3 w-100">{{
        'worksheet.download' | translate
      }}</a>
    </div>
  </div>
</ng-container>
